
   
const countryRedirects = {
  "UK": "azha-uk.myshopify.com",
  "QA": "qa.azhaperfumes.com",
  "KW": "kw.azhaperfumes.com",
  "OM": "azha-om.myshopify.com",
  "BH": "azha-bh.myshopify.com",
  "SA": "azha-ksa.myshopify.com",
  "AE": "azha-uae.myshopify.com",
  "US": "azhausa.com",
  "NL": "azha-eu.myshopify.com",
  "BE": "azha-eu.myshopify.com",
  "BG": "azha-eu.myshopify.com",
  "CY": "azha-eu.myshopify.com",
  "DK": "azha-eu.myshopify.com",
  "DE": "azha-eu.myshopify.com",
  "EE": "azha-eu.myshopify.com",
  "FI": "azha-eu.myshopify.com",
  "FR": "azha-eu.myshopify.com",
  "GR": "azha-eu.myshopify.com",
  "HU": "azha-eu.myshopify.com",
  "IE": "azha-eu.myshopify.com",
  "IT": "azha-eu.myshopify.com",
  "HR": "azha-eu.myshopify.com",
  "LV": "azha-eu.myshopify.com",
  "LU": "azha-eu.myshopify.com",
  "MT": "azha-eu.myshopify.com",
  "AT": "azha-eu.myshopify.com",
  "PL": "azha-eu.myshopify.com",
  "PT": "azha-eu.myshopify.com",
  "RO": "azha-eu.myshopify.com",
  "SI": "azha-eu.myshopify.com",
  "SK": "azha-eu.myshopify.com",
  "ES": "azha-eu.myshopify.com",
  "CZ": "azha-eu.myshopify.com",
  "SE": "azha-eu.myshopify.com",
  "CH": "azha-row.myshopify.com",
  "NO": "azha-row.myshopify.com",
  "BA": "azha-row.myshopify.com",
  "IS": "azha-row.myshopify.com",
  "LI": "azha-row.myshopify.com",
  "MC": "azha-row.myshopify.com",
  "RS": "azha-row.myshopify.com",
  "AU": "azha-row.myshopify.com",
  "BR": "azha-row.myshopify.com",
  "CA": "azha-row.myshopify.com",
  "CN": "azha-row.myshopify.com",
  "HK": "azha-row.myshopify.com",
  "JP": "azha-row.myshopify.com",
  "NZ": "azha-row.myshopify.com",
  "AE": "azhaperfumes.com",
  "AE": "azhaperfumes.ae",
  "AE": "uae.azhaperfumes.com"

};
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length > 1) {
    return parts.pop().split(';').shift();
  }
  return null;
}

if (window.location.hostname === "uae.azhaperfumes.com") {
  let cookieValue = getCookie('countryValue')
  $.getJSON("https://ipapi.co/json/", function (data) {
    if (!data || !data.country_code) {
        console.error("Invalid response from geolocation API.");
        return;
    }

    const countryCode = data.country_code;
    console.log("Detected country code:", countryCode);

    if (!['AE'].includes(countryCode)) {
        let cookieValue = getCookie('countryValue');
        console.log("cookieValue:", cookieValue);

        const redirectUrl = countryRedirects[countryCode];
        if (redirectUrl && redirectUrl !== window.location.hostname && !['AE'].includes(cookieValue)) {
          console.log(`Redirecting to ${redirectUrl} based on API data.`);
            window.location.hostname = redirectUrl;
        } else {
            console.log("No redirection required.");
        }
    }
}).fail(function () {
    console.error("Failed to fetch geolocation data.");
});

}